export default __webpack_public_path__ + "static/media/kinder1.a22f6db3.jpg";